import { Header4, Header5 } from 'library/styles/text';
import { Icon } from 'library/components/item/styles';
import { ButtonBack } from 'library/styles/button';
import { IconBase } from 'library/styles/icon';
import Image from 'library/components/image';
import {
  useHistory, useParams,
} from 'react-router-dom';
import React, {
  startTransition, useCallback, useEffect, useState,
} from 'react';
import {
  deleteProject,
  editProject,
  batchAddToProject,
  getProject as getProjectAction, resetProject,
} from 'store/project/actions';
import {
  getProject as getProjectSelector, getProjectSelectedDataIds,
} from 'store/project/selectors';
import { useSelector, useDispatch } from 'react-redux';
import ItemGrid from 'library/components/view-mode/grid/item';
import SetGrid from 'library/components/view-mode/grid/set';
import { MODES as COLOR_MODES } from 'library/components/color/constants';
import Gallery from 'library/components/gallery';
import { OverlayImage } from 'library/components/slider/styles';
import EditProjectModal from 'library/components/modal/input';
import * as yup from 'yup';
import { TYPE } from 'store/browse-items/fixtures';
import Item from 'library/components/item';
import { CSSTransition } from 'react-transition-group';
import DeleteItemsModal from 'library/components/modal/batch-confirm';
import GridContainer from 'library/components/grid-items-container';
import SearchByColorModal from 'library/components/modal/pick-color';
import UploadModal from 'library/components/modal/image-upload';
import PickItemsFromCatalogue from 'library/components/modal/pick-items-from-catelogue';
import NoContent from 'library/components/no-content';
import AddButton from 'library/components/add-button';
import {
  createImage, resetImage, createImageByUrl, resetImageByUrl,
} from 'store/images/actions';
import {
  createImageData,
  createImageLoading,
  createImageByUrlData,
  createImageByUrlLoading,
} from 'store/images/selectors';
import { resetBrowseItems } from 'store/browse-items/actions';
import useSetList from 'library/hooks/use-deferred-data/use-set-list';
import AddToContainerEntityModal from 'library/components/modal/pick-entity';
import {
  Container,
  Header,
  Actions,
  Meta,
  ActionIcon,
  Row,
  RowHeader,
  RowColors,
  ImageContainer,
  Image as ImageBlock,
  RowImages,
  StyledColor,
  Overlay,
  RowContainer,
} from './styles';
import { ACTIONS } from './constants';
import { getViewMode } from '../../../../store/shared/selectors';

const setIdValidation = yup.object().shape({
  id: yup.number(),
});

const validation = yup.object().shape({
  name: yup
    .string()
    .required('Project name is required field')
    .min(2, 'Name is too short')
    .max(30, 'Name is too long'),
});

const colorValidation = yup.object().shape({
  colors: yup.array().of(yup.string().required('Colors are required')).min(1, 'At least one color is required'),
});

const fileValidation = yup.object().shape({
  files: yup.array().of(yup.object().shape({
    id: yup.number(),
  })).min(1),
  images: yup.mixed(),
  urls: yup.array().of(yup.object().shape({
    value: yup.string().url('Invalid image url').test(
      'validFormat',
      'Invalid image extension, must be one of: jpg, webp, gif, png.',
      (value) => {
        if (typeof value !== 'string') {
          return false;
        }

        if (value === '') {
          return true;
        }

        return (value.match(/^http[^?]*.(jpg|png|gif|webp)(\?(.*))?$/gmi) !== null);
      },
    ),
  })).min(1),
});

const Project = ({
  openedItemId, onSelect, handleCloseItem, handleOpenItem, handleResetItem,
}) => {
  const [loadedData, setLoadedData] = useState({});
  const [loadedImagesData, setLoadedImagesData] = useState({});

  const [deleteModalOpened, toggleDeleteModal] = useState(false);
  const [editModalOpened, toggleEditModal] = useState(false);
  const dispatch = useDispatch();
  const [isUploadOpened, setUploadOpened] = useState(false);
  const isImageLoading = useSelector(createImageLoading);
  const isImageByUrlLoading = useSelector(createImageByUrlLoading);
  const data = useSelector(getProjectSelector);
  // const isLoading = useSelector(getProjectsLoading);
  const history = useHistory();
  const newImageData = useSelector(createImageData);
  const newImageByUrlData = useSelector(createImageByUrlData);
  const [isGalleryOpened, setGalleryIsOpened] = useState(false);
  const [isAddColorModalOpened, toggleAddColorModal] = useState(false);
  const [isCatalogueOpened, toggleCatalogue] = useState(false);
  const [openedGalleryImageId, setOpenedGalleryImageId] = useState(null);
  const { id } = useParams();
  const {
    selectedProjectImageIds,
    selectedProjectItemIds,
    selectedProjectSetIds,
    selectedProjectColorIds,
  } = useSelector(getProjectSelectedDataIds);
  const mode = useSelector(getViewMode);
  const { options: setOptions, isLoading: isSetLoading, onQueryChange: onSetQueryChange } = useSetList(!data);
  const [addToSetModalOpened, toggleAddToSetModal] = useState(false);

  const handleAddSetModalOpen = () => {
    toggleAddToSetModal(true);
  };

  const handleAddSetModalClose = () => {
    toggleAddToSetModal(false);
  };

  const handleGalleryClose = () => {
    setGalleryIsOpened(false);
    setOpenedGalleryImageId(null);
  };

  const handleGalleryOpen = (imageId) => {
    setGalleryIsOpened(true);
    setOpenedGalleryImageId(imageId);
  };

  useEffect(() => {
    if (id) {
      dispatch(getProjectAction({ id }));
    }

    return () => {
      dispatch(resetProject());
    };
  }, [id]);

  const renderItem = (item) => {
    const isSelected = selectedProjectItemIds.includes(item.id);
    const isOpened = openedItemId === item.id;

    const handleSelect = (e) => {
      e.stopPropagation();

      onSelect({
        id: item.id,
        type: TYPE.ITEM,
      }, isSelected);
    };

    return (
      <ItemGrid
        item={item}
        key={item.id}
        isSelected={isSelected}
        isOpened={isOpened}
        onSelect={handleSelect}
        onOpen={handleOpenItem}
        height={loadedData[item.id]}
      />
    );
  };

  const renderSet = (item) => {
    const isSelected = selectedProjectSetIds.includes(item.id);

    const onOpen = () => {
      history.push(`/browse${mode}/set-details/${item.id}`);
    };

    const handleSelect = (e) => {
      e.stopPropagation();

      onSelect({
        id: item.id,
        type: TYPE.SET,
      }, isSelected);
    };

    return (
      <SetGrid
        item={item}
        key={item.id}
        isSelected={isSelected}
        // isOpened={isOpened}
        onSelect={handleSelect}
        onOpen={onOpen}
      />
    );
  };

  const renderImage = (image) => {
    const isSelected = selectedProjectImageIds.includes(image.id);

    const onItemClick = () => {
      handleGalleryOpen(image.id);
    };
    // const src = getThumbnailImageSource(image);

    const handleSelect = (e) => {
      e.stopPropagation();

      onSelect({
        id: image.id,
        type: TYPE.IMAGE,
      }, isSelected);
    };

    return (
      <ImageBlock key={image.id}>
        <ImageContainer onClick={onItemClick ? () => onItemClick(id) : undefined} isSelected={isSelected}>
          <OverlayImage>
            <Icon className="icon-check-inverse" onClick={handleSelect} />
            <Icon className="icon-options-vertical" />
            <Icon className="icon-magnifier-add" />
          </OverlayImage>
          <Image name={image.url} id={image.id} source={image} isNew={image.isNew} height={loadedImagesData[image.id]} isLoaded={false} />
        </ImageContainer>
      </ImageBlock>
    );
  };

  const renderColor = (color) => {
    const isSelected = selectedProjectColorIds.includes(color.id);

    const handleSelect = () => {
      onSelect({
        id: color.id,
        type: TYPE.COLOR,
      }, isSelected);
    };

    return (
      <StyledColor
        key={color.id}
        color={`${color?.value.includes('#') ? '' : '#'}${color.value}`}
        huge
        mode={COLOR_MODES.SELECT}
        isSelected={isSelected}
        selectAction={handleSelect}
      />
    );
  };
  const handleDeleteProjectModalClose = () => {
    toggleDeleteModal(false);
  };

  const handleDeleteProjectModalOpen = () => {
    toggleDeleteModal(true);
  };

  const handleDeleteSubmit = () => {
    dispatch(deleteProject({ id }));

    history.goBack();
  };

  const handleEditProjectModalClose = () => {
    toggleEditModal(false);
  };

  const handleEditProjectModalOpen = () => {
    toggleEditModal(true);
  };

  const handleEditSubmit = (editedData) => {
    dispatch(editProject({ id, data: editedData }));

    handleEditProjectModalClose();
  };

  const handleAddColorsModalOpen = () => {
    toggleAddColorModal(true);
  };

  const handleAddColorsModalClose = () => {
    toggleAddColorModal(false);
  };

  const handleAddColorsSubmit = ({ colors }) => {
    dispatch(batchAddToProject({
      id,
      colors,
      type: 'COLORS',
      messages: { success: 'Color(s) added successfully' },
      resetProject: true,
    }));

    handleAddColorsModalClose();
  };

  const onImageUrlReset = () => {
    dispatch(resetImageByUrl());
  };

  const onFileReset = () => {
    dispatch(resetImage());
  };

  const onFileUpload = (file) => {
    dispatch(createImage({ data: file }));
  };

  const onImageUrlUpload = (urlData) => {
    dispatch(createImageByUrl(urlData));
  };

  const handleUploadModalOpen = () => {
    setUploadOpened(true);
  };
  const handleUploadModalClose = () => {
    setUploadOpened(false);
  };

  const onFileSubmit = ({ files }) => {
    const ids = files.map(({ id: fileId }) => fileId);
    dispatch(batchAddToProject({
      id,
      ids,
      type: 'IMAGE',
      messages: { success: 'Image(s) added successfully' },
      resetProject: true,
    }));

    handleUploadModalClose();
  };

  const handleCatalogueModalClose = () => {
    toggleCatalogue(false);
    dispatch(resetBrowseItems());
  };

  const handleCatalogueSubmit = (ids) => {
    dispatch(batchAddToProject({
      id, ids, type: 'ITEM', messages: { success: 'Item(s) added successfully' }, resetProject: true,
    }));

    handleCatalogueModalClose();
  };

  const handleAddSetSubmit = ({ id: setId }) => {
    dispatch(batchAddToProject({
      id, ids: [setId], type: 'SET', messages: { success: 'Set added successfully' }, resetProject: true,
    }));

    handleAddSetModalClose();
  };

  const actions = [
    {
      id: 'catalogue',
      label: 'Pick an existing item',
      icon: 'icon-magnifier',
      action: () => {
        toggleCatalogue(true);
      },
    },
    {
      id: 'color',
      label: 'Add colors to project',
      icon: 'icon-colors',
      action: () => {
        toggleAddColorModal(true);
      },
    },
    {
      id: 'image',
      label: 'Add image to project',
      icon: 'icon-picture',
      action: () => {
        setUploadOpened(true);
      },
    },
    {
      id: 'set',
      label: 'Add set to project',
      icon: 'icon-set',
      action: () => {
        handleAddSetModalOpen();
      },
    },
  ];

  const renderAction = ({ name }) => {
    switch (name) {
    case 'pencil': {
      return (
        <ActionIcon key={name} actionType={name} onClick={handleEditProjectModalOpen}>
          <Icon className={`icon-${name}`} />
        </ActionIcon>
      );
    }
    case 'trash': {
      return (
        <ActionIcon key={name} actionType={name} onClick={handleDeleteProjectModalOpen}>
          <Icon className={`icon-${name}`} />
        </ActionIcon>
      );
    }
    case 'colors': {
      return (
        <ActionIcon key={name} actionType={name} onClick={handleAddColorsModalOpen}>
          <Icon className={`icon-${name}`} />
        </ActionIcon>
      );
    }
    case 'picture': {
      return (
        <ActionIcon key={name} actionType={name} onClick={handleUploadModalOpen}>
          <Icon className={`icon-${name}`} />
        </ActionIcon>
      );
    }
    }

    return null;
  };
  const isEmptyProject = !data?.images.length && !data?.items.length && !data?.colors.length && !data?.sets.length;
  const getGridItems = useCallback(() => data?.items.map(renderItem), [data?.items, openedItemId, loadedData, selectedProjectItemIds]);
  const getGridImages = useCallback(() => data?.images.map(renderImage), [data?.images, loadedImagesData, selectedProjectImageIds]);
  const isImagesLoaded = data?.images.length && data?.images.length === Object.keys(loadedImagesData).length;

  return (
    <Container>
      <Header isShrunk={!!openedItemId}>
        <Meta>
          <ButtonBack onClick={() => history.goBack()}>
            <IconBase className="icon-arrow-left" />
            Back
          </ButtonBack>
          <Header4>{data?.name}</Header4>
        </Meta>
        <Actions>
          {ACTIONS.map(renderAction)}
        </Actions>
      </Header>
      {
        data?.images.length ? (
          <RowContainer isLoaded={isImagesLoaded}>
            <RowHeader>
              <Header5>
                Images (
                {data?.images.length}
                )
              </Header5>
            </RowHeader>
            <RowImages>
              {/* <GridContainer> */}
              {/*  {data?.images.length ? data?.images.map(renderImage) : null} */}
              {/* </GridContainer> */}
              <GridContainer onImagesLoaded={({ images, progressedCount }) => {
                if(progressedCount !== Object.keys(loadedImagesData).length) {
                  // eslint-disable-next-line no-shadow
                  startTransition(() => setLoadedImagesData(data.images.reduce((result, { id }, index) => {
                    if(!images[index]?.isLoaded || (images[index]?.isLoaded && result[data.images[index]?.id])) {
                      return result;
                    }
                    return {
                      ...result,
                      [data.images[index]?.id]: images[index]?.img?.clientHeight,
                    };
                  }, { ...loadedImagesData })));
                }
              }}
              >
                {getGridImages()}
              </GridContainer>
            </RowImages>
          </RowContainer>
        ) : null
      }
      {data?.colors?.length ? (
        <RowHeader>
          <Header5>
            Colors (
            {data?.colors.length}
            )
          </Header5>
        </RowHeader>
      ) : null}
      <RowColors>
        {data?.colors ? data?.colors.map(renderColor) : null}
      </RowColors>
      {data?.sets?.length ? (
        <RowHeader>
          <Header5>
            Sets(
            {data?.sets?.length}
            )
          </Header5>
        </RowHeader>
      ) : null}
      <Row>
        {data?.sets ? data.sets.map(renderSet) : null}
      </Row>
      {
        data?.items.length ? (
          <RowContainer isLoaded={data?.items.length && data?.items.length === Object.keys(loadedData).length}>
            {data?.items?.length ? (
              <RowHeader>
                <Header5>
                  Items(
                  {data?.items?.length}
                  )
                </Header5>
              </RowHeader>
            ) : null}
            <Row>
              <GridContainer onImagesLoaded={({ images, progressedCount }) => {
                if(progressedCount !== Object.keys(loadedData).length) {
                  // eslint-disable-next-line no-shadow
                  startTransition(() => setLoadedData(data.items.reduce((result, { id }, index) => {
                    if(!images[index]?.isLoaded || (images[index]?.isLoaded && result[data.items[index]?.id])) {
                      return result;
                    }

                    return {
                      ...result,
                      [data.items[index]?.id]: images[index]?.img?.clientHeight,
                    };
                  }, { ...loadedData })));
                }
              }}
              >
                {getGridItems()}
              </GridContainer>
            </Row>
          </RowContainer>
        ) : null
      }
      {isGalleryOpened && data?.images && (
        <Gallery
          data={data?.images}
          onClose={handleGalleryClose}
          openedImageId={openedGalleryImageId}
        />
      )}
      {isEmptyProject && data ? <NoContent title="Empty project" /> : null}
      {!!openedItemId && <Overlay onClick={handleCloseItem} />}
      <CSSTransition
        mountOnEnter
        unmountOnExit
        timeout={300}
        classNames="slide"
        in={!!openedItemId}
        appear={!!openedItemId}
        onExited={handleResetItem}
      >
        <Item openedItemId={openedItemId} onClose={handleCloseItem} />
      </CSSTransition>
      <DeleteItemsModal
        text="You are about to delete selected set, are you sure?"
        itemText={data?.name}
        title="Delete item?"
        submitText="Yes"
        cancelText="Cancel"
        isOpened={deleteModalOpened}
        onClose={handleDeleteProjectModalClose}
        onSubmit={handleDeleteSubmit}
        overlayClassName="Overlay"
      />
      <EditProjectModal
        title="Edit project"
        iconClassName="icon-pencil"
        submitText="Submit"
        cancelText="Cancel"
        isOpened={editModalOpened}
        onClose={handleEditProjectModalClose}
        onSubmit={handleEditSubmit}
        overlayClassName="Overlay"
        placeholder="Come up with a name for your project"
        validation={validation}
        defaultValue={data?.name}
      />
      <SearchByColorModal
        text=""
        isCancelDisplayed={false}
        contrastingFooter
        name="colors"
        title="Add colors to project"
        submitText="Submit"
        isOpened={isAddColorModalOpened}
        onClose={handleAddColorsModalClose}
        onSubmit={handleAddColorsSubmit}
        validation={colorValidation}
        defaultValues={{ colors: [] }}
        overlayClassName="Overlay"
      />
      <UploadModal
        text=""
        autocomplete="off"
        contrastingFooter
        name="files"
        title="Add image to project"
        submitText="Add image to project"
        isOpened={isUploadOpened}
        onClose={handleUploadModalClose}
        onReset={onFileReset}
        onResetImageUrl={onImageUrlReset}
        onUpload={onFileUpload}
        onImageUrlUpload={onImageUrlUpload}
        isLoading={isImageLoading || isImageByUrlLoading}
        newImageData={newImageData}
        newImageByUrlData={newImageByUrlData}
        shouldUnregister={false}
        onSubmit={onFileSubmit}
        defaultValues={{
          files: [],
          images: [],
          urls: [{ value: '' }],
        }}
        validation={fileValidation}
        overlayClassName="Overlay"
      />
      <AddButton isShifted={!!openedItemId} data={actions} />
      <PickItemsFromCatalogue
        width="1020px"
        title="Pick an existing item"
        submitText="Save"
        isOpened={isCatalogueOpened}
        onClose={handleCatalogueModalClose}
        onSubmit={handleCatalogueSubmit}
      />
      <AddToContainerEntityModal
        isSetList
        isMultipleAllowed={false}
        text="Add set to project"
        name="id"
        title="Add set to project"
        placeholder="Search for sets"
        submitText="Save changes"
        cancelText="Cancel"
        isOpened={addToSetModalOpened}
        isLoading={isSetLoading}
        onClose={handleAddSetModalClose}
        onSubmit={handleAddSetSubmit}
        onSearch={onSetQueryChange}
        options={setOptions}
        validation={setIdValidation}
        defaultValue={undefined}
        overlayClassName="Overlay"
        cancelWidth="94px"
      />
    </Container>
  );
};

export default Project;
